import { render, staticRenderFns } from "./SeoText.vue?vue&type=template&id=5c8355fc&scoped=true&"
import script from "./SeoText.vue?vue&type=script&lang=js&"
export * from "./SeoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8355fc",
  null
  
)

export default component.exports